<template>
	<el-input
		ref="input"
		class="input-sigarus-plantilla"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
	/>
</template>

<script>
	export default {
		name: 'InputSigarusPlantilla',
		props: {
			value: {
				default: ''
			},
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) { this.$emit('input', val) }

			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) }

		}
	}
</script>
